import IconButton from '@material-ui/core/IconButton';
import classNames from 'classnames';
import React from 'react';
import OutlineButton from '../OutlineButton/OutlineButton';
import TicketIcon from '../TicketIcon/TicketIcon';
import { getTicketsUrl } from './getTicketsUrl';
import styles from './BuyTickets.module.scss';

const TicketIconDisplay = (props: any) => (
    <TicketIcon className={classNames(styles.TicketIcon, { [styles.BigFormat]: props.big })} />
);

const BuyTickets = (props: any) => {
    if (props.hide || !props.event.ticketsSeller) return null;

    const url = getTicketsUrl(props.event);

    if (props.button) {
        return <OutlineButton name="Comprar Bilhete" route={url}  />;
    }

    return (
        <IconButton href={url} target="_blank" rel="noopener noreferrer" style={{ padding: 0 }}>
            <TicketIconDisplay {...props} />
        </IconButton>
    );
};


export default BuyTickets;
